export default "__VITE_ASSET__DyfvcA98__"